<template>
  <Layout>
  <div class="row mb-3">
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center justify-content-between pb-0">
        <div class="d-flex align-items-center">
          <div>
              <b-button pill variant="light" @click="backUrl">
                <i class="mdi mdi-18px mdi-arrow-left"></i>
              </b-button>
          </div>
          <h4 class="ml-2 mb-0 font-size-18">{{ title }}</h4>
        </div>

        <div class="page-title-right">
          <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>
        </div>
      </div>
      <!-- <hr> -->
    </div>
  </div>

  <!-- Person details & top mention -->
  <div class="row" v-if="id1 && id2">
      <div class="col-12">
         <Account
            :id1="id1"
            :id2="id2"
        />
      </div>
  </div>

  <div class="row mt-2 mb-4" v-if="!id1 && !id2">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
             <div class="col-6">
              <div class="row">
                <div class="col-sm-12">
                    <h6><b>Account 1</b></h6>
                    <div class="media" v-if="selected[0]">
                      <img
                          :src="selected[0].avatar"
                          class="mr-3 rounded-circle avatar-sm"
                          alt="user-pic"
                          />
                      <div class="media-body">
                        <b> {{selected[0].name}}</b> <span v-if="selected[0].verified == true"><i class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"></i></span> <br>
                        <span class="text-secondary"> @{{selected[0].account}}</span> <br>
                        <p class="text-secondary">{{ $t('all.updated') }}: {{selected[0].updated_at}} </p> 
                      </div>
                    </div>
                    <div class="media" v-else>
                     <span>Select Account</span>
                    </div>
                </div>
              </div>
             </div>
             <div class="col-6">
               <div class="row">
                <div class="col-sm-12">
                    <h6><b>Account 2</b></h6>
                    <div class="media" v-if="selected[1]">
                      <img
                          :src="selected[1].avatar"
                          class="mr-3 rounded-circle avatar-sm"
                          alt="user-pic"
                          />
                      <div class="media-body">
                        <b> {{selected[1].name}}</b> <span v-if="selected[1].verified == true"><i class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"></i></span> <br>
                        <span class="text-secondary"> @{{selected[1].account}}</span> <br>
                        <p class="text-secondary">{{ $t('all.updated') }}: {{selected[1].updated_at}} </p> 
                      </div>
                    </div>
                    <div class="media" v-else>
                     <span>Select Account</span>
                    </div>
                </div>
              </div>
             </div>
             </div>
             <div class="col-12 text-right" v-if="selected[1]">
                <button class="btn btn-success" @click="compareAccount(selected[0].account, selected[1].account)">
                <i class="bx bx-user"></i> Compare
                </button>
             </div>
            </div>
            <!-- Table -->
          </div>
      </div>
  </div>

  <div class="row mt-2 mb-4" v-if="!id1 && !id2">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  {{ $t('button.show') }}&nbsp;&nbsp;
                  <b-form-select v-model="perPage" size="sm" :options="pageOptions" class="mx-0"></b-form-select>&nbsp;&nbsp;{{ $t('button.entries') }} 
                </label> 
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                  {{ $t('button.search-data') }}
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                striped bordered
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
              <template #cell(no)="row" width="3%">
                <div class="mt-2">
                  {{row.item.no}}
                </div>
              </template>
              <template #cell(bulk)="row" width="3%">
              <b-form-checkbox
                class="text-center mt-2"
                v-model="selected"
                :value="row.item"
              >
              </b-form-checkbox>
              </template>
                <template #cell(account)="row"> 
                <div class="col-sm-12">
                    <div class="media">
                      <img
                          :src="row.item.avatar"
                          class="mr-3 rounded-circle avatar-sm"
                          alt="user-pic"
                          />
                      <div class="media-body">
                        <b> {{row.item.name}}</b> <span v-if="row.item.verified == true"><i class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"></i></span> <br>
                        <span class="text-secondary"> @{{row.item.account}}</span> <br>
                        <p class="text-secondary">{{ $t('all.updated') }}: {{row.item.updated_at}} </p> 
                      </div>
                    </div>
                </div>
                   
                </template>
                <!-- <template #cell(status)="row">  
                   <span class="badge badge-success p-1 px-1" variant="danger" v-if="row.item.status == 1"> Active</span>
                   <span class="badge badge-danger p-1 px-1" v-else-if="row.item.status == 0">Non Active</span>
                </template> -->
             
              </b-table>

               <div v-if="loadingInfo" class="mt-4 mx-auto p-5">
                    <div class="text-center">
                      <div class="spinner-border text-secondary" role="status" v-if="loadingInfo">
                      </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="!loadingInfo && rows > 10">
                <div class="col-2 col-xl-1">
                    <!-- <div v-if="selected[0]">
                      <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                    </div> -->
                    <label class="d-inline-flex align-items-center">
                      Page
                      <b-form-input
                        v-model="currentPage"
                        placeholder="Page"
                        class="form-control w-10 form-control ml-2"
                      ></b-form-input>
                    </label>
                </div>
                <div class="col-10 col-xl-11 text-right" v-if="rows > 10">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
  </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import VueWordCloud from "vuewordcloud";
import TwintService from "@/helpers/twint.service";
import PreferenceService from "@/helpers/preference.service.js";
import SosmedService from "@/helpers/socmed.service";
import moment from "moment";
import Account from "./compare-account.vue";
import { gmapApi } from "vue2-google-maps";
import SocmedService from "@/helpers/socmed.service";
import Swal from "sweetalert2";

import { ref } from "vue";

/**
 * Profile component
 */
export default {
  page: {
    title: "Twitter Compare",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, VueWordCloud, Account  },
  data() {
    let sentimenOptions = {
      series: [],
    };

    let sourceOptions = {
      series: [],
    };

    return {
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Twitter",
          href: "/twitter",
        },
        {
          text: "Compare",
          active: true,
        },
      ],
      title: "Twitter Compare",
      theme: localStorage.getItem('theme'),
      id1: this.$route.query.account1,
      id2: this.$route.query.account2,
      tableData:[],
      total_results:"",
      selected: [],
      selectedCompare:[],
      selectAll: false,
      search:false,
      loadingInfo:false,
      searchKey: '',
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Twitter",
          active: true
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "no",  class: 'text-center', thStyle: { width: "2%" }, label:'No'},
        { key: "bulk",  thStyle: { width: "2%" }, label:'#'},
        { key: "id_twitter", thClass: 'd-none', tdClass: 'd-none'},
        { key: "user_id", thClass: 'd-none', tdClass: 'd-none'},
        { key: "avatar", thClass: 'd-none', tdClass: 'd-none'},
        { key: "updated_at", thClass: 'd-none', tdClass: 'd-none'},
        { key: "name", thClass: 'd-none', tdClass: 'd-none'},
        { key: "account", sortable: true,  label: this.$t('twitter.table.account')},
        { key: "followers", sortable: true,  label: this.$t('twitter.table.followers') },
        { key: "following", sortable: true,  label: this.$t('twitter.table.following') },
        { key: "tweets", sortable: true,  label: this.$t('twitter.table.post') },
      ],
      trends24: {
        list : [],
        last_update : '',
      },
      activequery: '',
    }
  },
   computed: {
    rows() {
      return this.tableData.length;
    }
  },
  methods:{
    searchTwitter(){
        this.search = true;
    },
    select() {
      console.log('log');
        this.selected = [];
        this.selectedCompare = [];
        if (!this.selectAll) {
            for (let i in this.tableData) {
                this.selected.push(this.tableData[i].id_twitter);
            }
        }
    },
      listTwitter(){
        this.loadingInfo = true;
        SocmedService.getAllTwitter()
        .then(response => {
                  this.tableData = []
                  this.total_results = response.data.data.length
                   response.data.data.forEach((val, index) => {
                      const data = {    
                      "no" : index+1,
                      "id_twitter" : val.id_twitter,
                      "user_id" : val.user_id,
                      "account" : val.account,
                      "name" : val.name,
                      "verified" : val.is_verified,
                      "avatar" : val.avatar,
                      "followers" : val.followers,
                      "following" : val.following,
                      "tweets" : val.tweets,
                      "join_at" : val.join_at,
                      "created_at" : this.formatDate(val.created_at),
                      "updated_at" : this.formatDate(val.updated_at),
                      }
                      this.tableData.push(data);
                      this.loadingInfo = false;
                  });
              })
              .catch(err => {
                  console.log(err);
                  this.loadingInfo = false;
          });
      },
      formatDate(value){
          return moment(value).format("dddd, YYYY-MM-DD hh:mm");
      },
      formatNumber(count, decimals = 2){
        const COUNT_ABBRS = [ '', 'K', 'M', 'B', 'T'];
        const i     = 0 === count ? count : Math.floor(Math.log(count) / Math.log(1000));
        let result  = parseFloat((count / Math.pow(1000, i)).toFixed(decimals));
        result += `${COUNT_ABBRS[i]}`; 
        return result;

      },
      diffTime(value){
        const currTime = moment().format("HH:mm:ss")
        const lastTime = moment(value).format("HH:mm:ss")
        const startTime = moment.duration(currTime, "HH:mm:ss")
        const endTime  = moment.duration(lastTime, "HH:mm:ss")
        const diff = startTime.subtract(endTime)
        this.trends24.last_update = diff._data;
      },
      onHover(id){
        this.activequery = id;
      },
      onLeave(){
        this.activequery = ''
      },
      compareAccount(account1, account2){
        // return location.replace('/twitter-compare?account1='+account1+'&account2='+account2+');
        return location.replace('/twitter-compare?account1='+account1+'&account2='+account2);
      },
      backUrl(){
        return location.replace('/twitter-compare');
      }
  },
  mounted(){
    console.log('ref ==> ',this.$refs);
    this.totalRows = this.items.length;
    this.listTwitter();
  }
};
</script>

<style scoped>
/* .card{
  border: 2px solid #f1f1f1;
} */
.my-custom-scrollbar {
  position: relative;
  height: 500px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>